import * as WS from '../webServices/cyMyManager';
type TableSediProps = {
    sede: WS.Plus.IF.SedeEsercente;
    passToModal: () => void;
};

export default function TableSedi(props: TableSediProps):JSX.Element {
    return (
        <tr onClick={props.passToModal} >
            <td className='table-cell-mobile'>
                <span className='table-label-mobile' style={{width: 'fit-content'}}>#{props.sede.Id}</span>
                <span className='table-title-mobile'>{props.sede.Denominazione}</span>
                <span className='table-subtitle-mobile'>{props.sede.Indirizzo} - {props.sede.Localita}</span>
            </td>
        </tr>
    )
}